import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { useHistory } from "react-router-dom";
import { getLoginToken } from '../../helpers/sessionHandler';
import { useMappedState } from 'redux-react-hook';

const styles = {
    root: {
        flexGrow: 1,
    },
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    menu: {
        width: 300,
        minWidth: 300
    }
}

const mapState = state => ({
    authentication: state.authentication,
});

const AppBarComponent = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { authentication } = useMappedState(mapState);
    const history = useHistory();

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRedirect = (newRoute) => {
        history.push(newRoute);
        // if(getLoginToken()) history.push(newRoute);
        // else history.push('/');
        handleClose();
    }

    const { classes } = props;
    const open = Boolean(anchorEl);
    const authenticationVal = authentication || getLoginToken();

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                {authenticationVal &&<div>
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Menu"
                            onClick={handleMenu}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            className={classes.menu}
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            onClose={handleClose}
                        >
                            {!authenticationVal && (<MenuItem onClick={() => handleRedirect('/')}>Start</MenuItem>)}
                            {authenticationVal && (<MenuItem onClick={() => handleRedirect('/messages')}>Wiadomości</MenuItem>)}
                            {authenticationVal && (<MenuItem onClick={() => handleRedirect('/invoices')}>Faktury</MenuItem>)}
                            {authenticationVal && (<MenuItem onClick={() => handleRedirect('/contact')}>Moje dane kontaktowe</MenuItem>)}
                            {authenticationVal && (<MenuItem onClick={() => handleRedirect('/bank')}>Konto do opłat</MenuItem>)}
                            {authenticationVal && (<MenuItem onClick={() => handleRedirect('/rodo')}>RODO</MenuItem>)}
                            {authenticationVal && (<MenuItem onClick={() => handleRedirect('/logout')}>Wyloguj się</MenuItem>)}
                        </Menu>
                    </div>}
                    <Typography variant="title" color="inherit" className={classes.flex}>
                        Witaj w EBOK
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );
}

AppBarComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppBarComponent);


// WEBPACK FOOTER //
// ./src/components/AppBar/AppBarComponent.js